"use client";

/**
 * 全局错误边界。
 *
 * 这个文件是 App Router 约定的最外层兜底入口：
 * - 负责捕获比 route error 更外层的渲染异常
 * - 仍然复用业务里的 AppErrorView，保证全局错误页和普通错误页视觉一致
 *
 * 注意：
 * global-error.tsx 不能和 app/error.tsx 合并成一个文件，
 * 因为 Next.js 对它们的文件名、渲染层级和返回结构有不同约定。
 */

import { AppErrorView } from "@/app/error";
import { monitor } from "@/lib/sentry/instrument";
import { useEffect } from "react";

export default function GlobalError( { error }: { error: Error & { digest?: string } } ) {
    useEffect( () => {
        // 全局错误边界兜底捕获最外层渲染异常，防止只剩浏览器白屏而没有事件记录。
        monitor.error( error, {
            tags: { error_type: "render", error_kind: "global_error_boundary" },
            contextName: "global_error",
            extra: { digest: error.digest },
        } );
    }, [ error ] );

    return (
        <html lang="en">
            <body className="fullscreen-element-safe w-full max-w-[500px]" id="viewport-height-provider">
                {/* 继续复用业务里的错误页样式，降低全局兜底页和普通错误页的割裂感。 */}
                <AppErrorView error={error} />
            </body>
        </html>
    );
}
